module.exports = __webpack_public_path__ + "img/EMS_user_manual18_Layout.afd3b4c4.png";